var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrequentQuetions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.422,
    height: 35.422,
    viewBox: "0 0 35.422 35.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_twotone_messages",
    "data-name": "vuesax/twotone/messages",
    transform: "translate(-556 -316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "messages",
    transform: "translate(556 316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.952 8.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.585,7.07v5.9a8.951,8.951,0,0,1-.059,1.107c-.339,3.985-2.686,5.963-7.011,5.963h-.59a1.188,1.188,0,0,0-.945.472l-1.771,2.361a1.67,1.67,0,0,1-2.834,0L8.6,20.515a1.363,1.363,0,0,0-.945-.472H7.07c-4.708,0-7.07-1.166-7.07-7.07V7.07C0,2.745,1.992.4,5.963.059A8.951,8.951,0,0,1,7.07,0h9.446Q23.578,0,23.585,7.07Z",
    fill: "none",
    stroke: "#ffaa8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M23.526,7.07v5.9q0,6.509-5.963,7.011a8.951,8.951,0,0,0,.059-1.107v-5.9q0-7.062-7.07-7.07H1.107A8.951,8.951,0,0,0,0,5.963C.339,1.992,2.686,0,7.011,0h9.446Q23.519,0,23.526,7.07Z",
    transform: "translate(8.915 2.952)",
    fill: "none",
    stroke: "#ffaa8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H35.422V35.422H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M.5.5H.509",
    transform: "translate(19.423 19.056)",
    fill: "none",
    stroke: "#ffaa8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M.5.5H.509",
    transform: "translate(14.257 19.056)",
    fill: "none",
    stroke: "#ffaa8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M.5.5H.509",
    transform: "translate(9.091 19.056)",
    fill: "none",
    stroke: "#ffaa8c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequentQuetions);
export default __webpack_public_path__ + "static/media/frequent-quetions.c6d3a87f0f410d8fa5281abf60595541.svg";
export { ForwardRef as ReactComponent };